import { KLIKIT_CDN_BASE_URL } from '../env';

export const NEW_NOTIFICATION_SOUND = `${KLIKIT_CDN_BASE_URL}/audio/new.wav`;
export const CANCELLED_ORDER_NOTIFICATION_SOUND = `${KLIKIT_CDN_BASE_URL}/audio/cancel.wav`;

export const ORDER_STATUS = {
  PLACED: 1,
  ACCEPTED: 2,
  CANCELLED: 3,
  READY: 4,
  DELIVERED: 5,
  SCHEDULED: 6,
  DRIVER_ASSIGNED: 7,
  DRIVER_ARRIVED: 8,
  PICKEDUP: 9,
  VOIDED: 11,
};

export const ORDER_STATUS_LIST = [
  { id: 1, status: 'Placed' },
  { id: 2, status: 'Accepted' },
  { id: 3, status: 'Cancelled' },
  { id: 4, status: 'Ready' },
  { id: 5, status: 'Delivered' },
  { id: 6, status: 'Scheduled' },
  { id: 7, status: 'Driver Assigned' },
  { id: 8, status: 'Driver Arrived' },
  { id: 9, status: 'Picked Up' },
  { id: 11, status: 'Voided' },
];

export const ORDER_TYPE = {
  DELIVER: 2,
  PICKUP: 1,
  DINE_IN: 3,
};
export const ORDER_TYPE_LIST = [
  { id: 1, label: 'Pickup' },
  { id: 2, label: 'Delivery' },
  {
    id: 3,
    label: 'Dine In',
  },
];

export const PAID_PAYMENT_STATUS_ID = 1;
export const PENDING_PAYMENT_STATUS_ID = 3;
export const FAILED_PAYMENT_STATUS_ID = 2;
export const DEFAULT_PAYMENT_STATUS_ID_FOR_MANUAL_ORDER =
  PENDING_PAYMENT_STATUS_ID;
export const DEFAULT_PAYMENT_STATUS_LABEL_FOR_MANUAL_ORDER = 'Pending';
export const DISCOUNT_TYPE = [
  {
    id: 1,
    title: 'Flat',
    value: 1,
  },
  {
    id: 2,
    title: 'Percent (%)',
    value: 2,
  },
];

export const DELIVERY_METHOD_ID = 2;

export const ACTIVE_ORDER_MODE = {
  title: 'Active Orders',
  id: 'active_orders',
};

export const PAST_ORDER_MODE = {
  title: 'Order History',
  id: 'past_orders',
};

export const ORDER_MODES = [ACTIVE_ORDER_MODE, PAST_ORDER_MODE];

export const OTHER_ORDER_SOURCE_ID = 10;
export const CUSTOMIZABLE_PRICE_TYPE = {
  DELIVERY_FEE: 'delivery_fee',
  DISCOUNT: 'discount_value',
  ADDITIONAL_FEE: 'additional_fee',
  IS_ROUNDING_OFF_APPLICABLE: 'is_rounding_off_applicable',
};

export const PAYMENT_STATUS_PAID_ID = 1;
export const PAYMENT_STATUS_REFUNDED_ID = 4;
export const PAYMENT_STATUS_REFUND_REQUESTED_ID = 5;
export const PAYMENT_STATUS_REFUND_REQUESTED_FAILED_ID = 6;
export const PAYMENT_STATUS_REFUND_FAILED = 7;

export const ORDER_FULFILLMENT_STATUS = {
  DISPATCHING: { id: 1, status: 'DISPATCHING', label: 'FINDING RIDER' },
  ALLOCATING: { id: 2, status: 'ALLOCATING', label: 'ALLOCATING RIDER' },
  PENDING_PICKUP: { id: 3, status: 'PENDING_PICKUP', label: 'FOUND RIDER' },
  PICKING_UP: { id: 4, status: 'PICKING_UP', label: 'PICKING UP' },
  IN_DELIVERY: { id: 5, status: 'IN_DELIVERY', label: 'IN DELIVERY' },
  COMPLETED: { id: 6, status: 'COMPLETED', label: 'COMPLETED' },
  RETURNED: { id: 7, status: 'RETURNED', label: 'RETURNED' },
  FAILED: { id: 8, status: 'FAILED', label: 'FAILED' },
  CANCELLED: { id: 9, status: 'CANCELLED', label: 'CANCELLED' },
  IN_RETURN: { id: 10, status: 'IN_RETURN', label: 'IN RETURN' },
  DISPATCH_FAILED: {
    id: 11,
    status: 'DISPATCH_FAILED',
    label: 'RIDER REQUEST FAILED',
  },
};

export const ORDER_FULFILLMENT_STATUS_IDS_HAVING_RIDER = [
  ORDER_FULFILLMENT_STATUS.PENDING_PICKUP.id,
  ORDER_FULFILLMENT_STATUS.PICKING_UP.id,
  ORDER_FULFILLMENT_STATUS.IN_DELIVERY.id,
  ORDER_FULFILLMENT_STATUS.COMPLETED.id,
  ORDER_FULFILLMENT_STATUS.IN_RETURN.id,
];

export const ORDER_CANCELLATION_LIST_TYPE_IDS = {
  RESTAURANT: 1,
  WEBSHOP: 2,
};
export const CANCELLATION_REASON_OTHER_ID = 7;

export const ORDER_CANCELLED_BY_LIST = [
  {
    id: 1,
    label: 'Restaurant',
  },
  {
    id: 2,
    label: 'Customer',
  },
  {
    id: 3,
    label: 'Provider',
  },
  {
    id: 4,
    label: 'Fulfillment Partner',
  },
  {
    id: 5,
    label: 'SYSTEM',
  },
];

export const PROVIDER_STATUS_ACTIVE = 'Active';
export const PROVIDER_STATUS_INACTIVE = 'Inactive';
export const PROVIDER_STATUS_NOT_AVAILABLE = 'N/A';

export const DRIVE_THRU_TYPE = {
  id: 2,
  label: 'Drive Thru',
};

export const CREATE_QRIS_ID = 37;

export const ACTIVE_ORDER_TABS = [
  {
    id: 1,
    title: 'All',
    orderStatus: [
      ORDER_STATUS.PLACED,
      ORDER_STATUS.ACCEPTED,
      ORDER_STATUS.READY,
      ORDER_STATUS.SCHEDULED,
      ORDER_STATUS.DRIVER_ASSIGNED,
      ORDER_STATUS.DRIVER_ARRIVED,
      ORDER_STATUS.PICKEDUP,
    ],
  },
  {
    id: 2,
    title: 'New',
    orderStatus: [ORDER_STATUS.PLACED, ORDER_STATUS.ACCEPTED],
  },
  {
    id: 3,
    title: 'Ready',
    orderStatus: [ORDER_STATUS.DRIVER_ARRIVED, ORDER_STATUS.READY],
  },
  {
    id: 4,
    title: 'Scheduled',
    orderStatus: [ORDER_STATUS.SCHEDULED],
  },
  {
    id: 5,
    title: 'Others',
    orderStatus: [
      ORDER_STATUS.DRIVER_ASSIGNED,
      ORDER_STATUS.DRIVER_ARRIVED,
      ORDER_STATUS.PICKEDUP,
    ],
  },
];

export const PAST_ORDER_TABS = [
  {
    id: 1,
    title: 'All',
    orderStatus: [
      ORDER_STATUS.CANCELLED,
      ORDER_STATUS.DELIVERED,
      ORDER_STATUS.VOIDED,
    ],
  },
  {
    id: 2,
    title: 'Complete',
    orderStatus: [ORDER_STATUS.DELIVERED],
  },
  {
    id: 3,
    title: 'Cancelled',
    orderStatus: [ORDER_STATUS.CANCELLED],
  },
  {
    id: 4,
    title: 'Voided',
    orderStatus: [ORDER_STATUS.VOIDED],
  },
];

export const ORDER_SEARCH_PARAMS = [
  {
    key: 'filterByExternalId',
    title: 'External ID',
  },
  {
    key: 'filterByOrderId',
    title: 'Order ID',
  },
  {
    key: 'filterByShortId',
    title: 'Short ID',
  },
];

export const KLIKIT_ORDER_SOURCES = [
  { id: 1, title: 'Add Order', filterByAddOrder: true },
  { id: 2, title: 'Webshop', filterByAddOrder: false },
];

export const PAST_ORDER_DATE_FORMAT = 'yyyy-MM-dd';

export const CANCELLED_ORDER_STATUS_IDS = [
  ORDER_STATUS.CANCELLED,
  ORDER_STATUS.VOIDED,
];

export const CANCELLED_FULFILLMENT_IDS = [
  ORDER_FULFILLMENT_STATUS.CANCELLED.id,
  ORDER_FULFILLMENT_STATUS.FAILED.id,
  ORDER_FULFILLMENT_STATUS.DISPATCH_FAILED.id,
];

export const RIDER_FULFILLMENT_IDS = [
  ORDER_FULFILLMENT_STATUS.PENDING_PICKUP.id,
  ORDER_FULFILLMENT_STATUS.PICKING_UP.id,
  ORDER_FULFILLMENT_STATUS.IN_DELIVERY.id,
  ORDER_FULFILLMENT_STATUS.COMPLETED.id,
  ORDER_FULFILLMENT_STATUS.IN_RETURN.id,
];

export const IN_HOUSE_FULFILLMENT_PROVIDER_ID = 1;

export const TIKTOK_SHOP_STATUSES = {
  ON: {
    id: 1,
    title: 'On',
    iconCls: 'text-green-dark',
  },
  OFF: {
    id: 0,
    title: 'Off',
    iconCls: 'text-grey-dark',
  },
  PENDING: {
    id: 2,
    title: 'Pending',
    iconCls: 'text-yellow-dark',
  },
};

export const ORDER_CANCEL_VIEWS = {
  CANCEL: 'cancel',
  REFUND: 'refund',
};

export const ORDER_REFUND_OPTIONS = [
  {
    id: 1,
    title: 'Yes',
    value: true,
  },
  {
    id: 2,
    title: 'No',
    value: false,
  },
];

// KDS (Kitchen Display System) View Constants
// Terminal states that should NOT appear in KDS: DELIVERED, PICKEDUP, CANCELLED, VOIDED
export const KDS_COLUMNS = {
  UPCOMING: {
    id: 'upcoming',
    title: 'Upcoming',
    // Scheduled orders not yet released to the kitchen. oni flips these to PLACED only
    // AcceptSchedOrderBeforeMinute before they are due (10 min default, 30 for Deliveroo), so
    // without this column they appear from nowhere minutes before service.
    orderStatus: [ORDER_STATUS.SCHEDULED],
  },
  NEW: {
    id: 'new',
    title: 'New',
    // New orders waiting to be accepted
    orderStatus: [ORDER_STATUS.PLACED],
  },
  PREPARING: {
    id: 'preparing',
    title: 'Preparing',
    // Accepted orders being prepared
    orderStatus: [ORDER_STATUS.ACCEPTED],
  },
  AWAITING_COLLECTION: {
    id: 'awaiting_collection',
    title: 'Awaiting Collection',
    // Ready orders (both pickup and delivery) waiting to be collected
    orderStatus: [
      ORDER_STATUS.READY,
      ORDER_STATUS.DRIVER_ASSIGNED,
      ORDER_STATUS.DRIVER_ARRIVED,
    ],
  },
};

export const KDS_COLUMN_LIST = [
  KDS_COLUMNS.UPCOMING,
  KDS_COLUMNS.NEW,
  KDS_COLUMNS.PREPARING,
  KDS_COLUMNS.AWAITING_COLLECTION,
];

export const KDS_LOCAL_STORAGE_KEY = 'kds_view_active';
export const KDS_SETTINGS_STORAGE_KEY = 'kds_settings';

// KDS renders every active order as a card and has no pagination control, so it cannot use the
// list view's DEFAULT_PAGE_SIZE of 10 — oni returns the newest 10 by created_at, which silently
// drops the OLDEST orders, exactly the ones at risk of breaching.
// Bounded rather than unbounded: this list is polled on an interval by every open KDS screen and
// the query behind it aggregates fulfillments per order.
export const KDS_PAGE_SIZE = 100;

// Statuses the KDS board renders as live work. SCHEDULED is deliberately absent — it is fetched
// separately (see KDS_SCHEDULED_ORDER_VIEW) because oni's default created_at window would hide
// orders placed more than 7 days ahead. PICKEDUP and terminal states have no column.
export const KDS_ACTIVE_ORDER_VIEW = {
  id: 'kds_active',
  title: 'KDS Active',
  orderStatus: [
    ORDER_STATUS.PLACED,
    ORDER_STATUS.ACCEPTED,
    ORDER_STATUS.READY,
    ORDER_STATUS.DRIVER_ASSIGNED,
    ORDER_STATUS.DRIVER_ARRIVED,
  ],
};

// Scheduled orders must be requested with SCHEDULED and nothing else: oni only waives its default
// "created_at within the last 7 days" filter when the status filter is scheduled-only
// (oni types/types.go). A florist taking orders three weeks out depends on that waiver.
export const KDS_SCHEDULED_ORDER_VIEW = {
  id: 'kds_scheduled',
  title: 'KDS Scheduled',
  orderStatus: [ORDER_STATUS.SCHEDULED],
};

// What the band across the top of a KDS card identifies. The channel logo is always kept, so this
// chooses the text identity, not whether the channel is visible.
export const KDS_CARD_IDENTIFIERS = [
  { id: 'channel', title: 'Channel' },
  { id: 'brand', title: 'Brand' },
  { id: 'store', title: 'Store' },
  { id: 'brand_store', title: 'Brand + Store' },
];

// How far ahead the Upcoming column looks. Anything beyond the horizon is counted in the column
// header rather than rendered, so a long pre-order book cannot bury today's work.
export const KDS_UPCOMING_HORIZONS = [
  { id: 4, title: 'Next 4 hours' },
  { id: 12, title: 'Next 12 hours' },
  { id: 24, title: 'Next 24 hours' },
  { id: 48, title: 'Next 48 hours' },
  { id: 0, title: 'All upcoming' },
];

// Kitchen is the working board (cards, items, actions). Pickup is the customer-facing screen
// (numbers only, no items, names or actions) meant for a TV over the collection point.
export const KDS_DISPLAY_MODES = [
  { id: 'kitchen', title: 'Kitchen board' },
  { id: 'pickup', title: 'Customer pickup board' },
];

// Font sizes in px, applied inline. Standard matches the original card; TV is sized to be read
// across a room from a wall-mounted screen.
export const KDS_TEXT_SIZES = [
  {
    id: 'standard',
    title: 'Standard',
    orderNumber: 18,
    columnTitle: 16,
    columnCount: 14,
    pickupNumber: 40,
    pickupTitle: 24,
  },
  {
    id: 'large',
    title: 'Large',
    orderNumber: 28,
    columnTitle: 22,
    columnCount: 18,
    pickupNumber: 56,
    pickupTitle: 32,
  },
  {
    id: 'tv',
    title: 'TV',
    orderNumber: 44,
    columnTitle: 30,
    columnCount: 24,
    pickupNumber: 80,
    pickupTitle: 44,
  },
];

// Per device, not per business: the hot line and the packing bench are different screens in the
// same store and legitimately want different boards.
export const KDS_DEFAULT_SETTINGS = {
  displayMode: 'kitchen',
  textSize: 'standard',
  columns: KDS_COLUMN_LIST.map(c => c.id),
  cardIdentifier: 'channel',
  showActionButtons: true,
  // Pickup board only. Logos are opt-in so a walk-in counter keeps a clean wall of numbers, and an
  // empty provider list means every channel, so a new integration appears without a settings edit.
  pickupShowChannelLogos: false,
  pickupProviderIds: [],
  upcomingHorizonHours: 24,
};
